import React, {Fragment, PureComponent, createRef} from "react";
import moment from "moment-timezone";
import Api from "../../utils/api_calls";
import "./Zoom.scss";

class Zoom extends PureComponent {
    timer = null;
    button = createRef();
    state = {
        isLive: false,
        showBar: false,
        days: "-",
        hours: "-",
        minutes: "-",
        event : null,
        seconds: "-"
    }
    normalizeTimeString(time){
        if(time){
            const timeArray = time.split(":");
            if(timeArray.length > 1){
                const hours = parseInt(timeArray[0]) < 10 ? "0"+parseInt(timeArray[0]) : timeArray[0];
                return `${hours}:${timeArray[1]}`;
            }
            else{
                return time;
            }
        }
    }
    createDate = (meeting) => {
        if (meeting && !meeting.enable) return;
        const dateString = meeting.date + "T" + this.normalizeTimeString(meeting.time);
        return moment.tz(dateString, meeting.timezone).format();
    }

    formatDate(date) {
        const months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sept', 'Oct', 'Nov', 'Dec'];
        const month = months[date.getMonth()];
        const day = '' + date.getDate() + ',';
        const year = date.getFullYear();
        return [month, day, year].join(' ');
    }
    getEvent=()=> {
        const that = this;
        Api.getLiveEvent(TVSite.ambassadorData.id).then( response => {
            if(response && response.data && response.data.enable === true){
                that.setState({
                    event: response.data
                });
                that.timer = setInterval(this.checkEnable, 1000);
            }
        });
    }

    componentDidMount() {
        this.getEvent();
    }

    getTimeDifference(dateToEvaluate) {
        return dateToEvaluate.getTime() - new Date().getTime();
    }

    checkEnable = () => {
        const meeting = this.state.event;
        if (meeting && meeting.enable) {
            const currentTime = new Date();
            const meetingDateStart = new Date(this.createDate(meeting));
            const duration = meeting.duration ? meeting.duration : 0;
            const hours = 0;
            const minutes = parseInt(duration);
            const meetingDateEnd = new Date(meetingDateStart.getFullYear(), meetingDateStart.getMonth(),
                meetingDateStart.getDate(), meetingDateStart.getHours() + hours, meetingDateStart.getMinutes() + minutes);
            const differenceStart = this.getTimeDifference(meetingDateStart);
            const differenceEnd = this.getTimeDifference(meetingDateEnd);
            if (differenceEnd < 0) {
                //expired - check dates a valid expired should be the start date/time plus duration
                // if expired disable the zoom bar
                clearInterval(this.timer);
                this.setState({
                    showBar: false
                })
            } else if (currentTime.getDate() >= differenceStart && currentTime.getDate() <= differenceEnd) {
                // is live
                this.setState({
                    isLive: true,
                    showBar: true
                });
            } else {
                //update timer
                const days = Math.floor(differenceStart / (1000 * 60 * 60 * 24));
                const hours = Math.floor((differenceStart % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                const minutes = Math.floor((differenceStart % (1000 * 60 * 60)) / (1000 * 60));
                const seconds = Math.floor((differenceStart % (1000 * 60)) / 1000);
                this.setState({
                    days: days,
                    hours: hours,
                    showBar: true,
                    minutes: minutes,
                    seconds: seconds
                });
            }
        } else {
            clearInterval(this.timer);
        }
        ;
    }

    normalizeHours(date) {
        const nDate = date.toLocaleTimeString("en-US");
        const hours = nDate.split(":")[0];
        if (parseInt(hours) < 10) {
            return "0" + hours;
        } else return hours;
    }

    getMinutes(date) {
        const minutes = date.getMinutes();
        if (minutes < 10)
            return "0" + minutes;
        else
            return minutes;
    }

    normalizeCountDown(timeLeft) {
        if (timeLeft < 10)
            return "0" + timeLeft;
        else
            return timeLeft;
    }
    invertColors = (data) =>{
        this.button.current.style.backgroundColor = "#ffffff";
        this.button.current.style.color = data.button_color;
    }
    normalColors = (data) => {
        this.button.current.style.backgroundColor = data.button_color;
        this.button.current.style.color = "#ffffff";
    }
    isValidDate = (date)=>{
        if(typeof date.getMonth === 'function' && !isNaN(date.getMonth())){
            return true;
        }else{
            const {event} = this.state;
            console.info("Live Shopping hidden - bad date information");
            console.info("Live Shopping timezone:", event.timezone);
            console.info("Live Shopping date:", event.date);
            console.info("Live Shopping time:", event.time);
            return false
        }
    }
    render() {
        const {isLive, showBar, days, hours, minutes, seconds, event} = this.state;
        const date = showBar ? new Date(this.createDate(event)) : new Date();
        const isValidDate = this.isValidDate(date);
        return <Fragment>
            {(showBar && isValidDate) && <div className={"zoom-bar"} style={{backgroundColor: event.background_color}}>
                {
                    event.event_title && <div className={"container"}>
                        <div className={"row"}>
                            <div className={"col-12 text-center tvp-event-title"}>
                                {event.event_title}
                            </div>
                        </div>
                    </div>
                }
                <div className={"container"}>
                    <div className={"row"}>
                        <div className={"col-12"}>
                            <div className={"zoom-bar-details"}>
                                <div className={"zoom-bar-details-logo"}>
                                    <img src={event.service_logo_url} alt={"Zoom"}/>
                                </div>
                                <div className={"zoom-bar-details-date"}>
                                    {this.formatDate(date)} @ {this.normalizeHours(date)}:{this.getMinutes(date)}{date.getHours() >= 12 ? "pm" : "am"}

                                </div>
                                <div className={"zoom-bar-details-timer"}>
                                    {!isLive ? <div className={"timer-center"}>
                                            <div className={"timer-item"}>
                                                <span className={"timer-item-time"}>{this.normalizeCountDown(days)}</span>
                                                <span className={"timer-item-name"}>DAYS</span>
                                            </div>
                                            <div className={"timer-item"}>
                                                <span className={"timer-item-time"}>{this.normalizeCountDown(hours)}</span>
                                                <span className={"timer-item-name"}>HOURS</span>
                                            </div>
                                            <div className={"timer-item"}>
                                                <span
                                                    className={"timer-item-time"}>{this.normalizeCountDown(minutes)}</span>
                                                <span className={"timer-item-name"}>MINUTES</span>
                                            </div>
                                            <div className={"timer-item"}>
                                                <span
                                                    className={"timer-item-time"}>{this.normalizeCountDown(seconds)}</span>
                                                <span className={"timer-item-name"}>SECONDS</span>
                                            </div>
                                        </div> :
                                        <div className={"im-live"}>
                                            <span>I’M LIVE</span>
                                        </div>
                                    }
                                </div>
                                <div className={"zoom-bar-details-button"}>
                                    <a href={event.link} target={"_new"}>
                                        <button ref={this.button}
                                        onMouseEnter={()=>this.invertColors(event)}
                                        onMouseLeave={()=>this.normalColors(event)}
                                        onTouchStart={()=>this.invertColors(event)}
                                        onTouchEnd={()=>this.normalColors(event)}
                                            className={"join"} style={{backgroundColor: event.button_color,
                                                                            borderColor: event.button_color}}>
                                            JOIN LIVE EVENT
                                        </button>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>}
        </Fragment>
    }
}

export default Zoom;